/* VSKLO product native video controls. Keeps Shopify product videos playable inside Swiper/zoom gallery. */
(function () {
  'use strict';

  if (window.__VSKLO_PRODUCT_VIDEO_PLAYER_V1__) return;
  window.__VSKLO_PRODUCT_VIDEO_PLAYER_V1__ = true;

  function prepareVideo(root) {
    if (!root || root.dataset.vskloVideoReady === 'true') return;

    var video = root.querySelector('video');
    var button = root.querySelector('[data-vsklo-product-video-play]');

    if (!video) return;

    root.dataset.vskloVideoReady = 'true';
    video.controls = true;
    video.playsInline = true;
    video.preload = video.getAttribute('preload') || 'metadata';
    video.removeAttribute('autoplay');
    video.autoplay = false;

    if (video.hasAttribute('muted')) {
      video.removeAttribute('muted');
      video.muted = false;
    }

    function syncState() {
      root.classList.toggle('is-playing', !video.paused && !video.ended);
    }

    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    video.addEventListener('ended', syncState);

    video.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    video.addEventListener('pointerdown', function (event) {
      event.stopPropagation();
    });

    if (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (video.paused || video.ended) {
          var playPromise = video.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
              video.controls = true;
            });
          }
        } else {
          video.pause();
        }
      });
    }

    syncState();
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-vsklo-product-video]')
      .forEach(prepareVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener(
    'click',
    function (event) {
      var root =
        event.target && event.target.closest
          ? event.target.closest('[data-vsklo-product-video]')
          : null;

      if (!root) return;

      if (
        event.target.closest('video') ||
        event.target.closest('[data-vsklo-product-video-play]')
      ) {
        return;
      }

      var button = root.querySelector(
        '[data-vsklo-product-video-play]'
      );

      if (button) button.click();
    },
    true
  );
})();